// PostHog direct loader (replaces former Segment-relay loader `segment-posthog-v1.js`).
//
// Runs in two contexts:
//   1. Main Angular webapp — loaded via `angular.json` `scripts`. The app also
//      initializes PostHog via `PosthogService`, so we guard against double-init.
//   2. Keycloak login / account themes — loaded via `theme.properties` `scripts`.
//      In that context this is the ONLY PostHog initializer on the page.
//
// Public surface (kept identical to the prior Segment-based script so call
// sites don't change):
//   - window.trackCustomEvent(eventName, properties)
//   - window.identifyUser(userId, traits)
//
// Also re-implements the `data-analytics` click tracking from the old script.

(function () {
  "use strict";

  // ---- API key selection (same host-based switch as the old script) ---------
  function getApiConfig() {
    var domain = window.location.hostname || "";
    if (domain.indexOf("qa.rysemarket.com") !== -1) {
      return {
        posthogKey: "phc_x4FoIMt44tpzEZ3EV7nxVQ4yDzKaNTjjnNa05RpmepW",
        posthogApiHost: "https://us.i.posthog.com",
      };
    }
    // Sandbox: analytics deliberately disabled (no PostHog project yet). MUST be
    // checked before the generic rysemarket.com branch below, which would
    // otherwise send sandbox traffic to the PROD project. Mirrors the empty
    // posthogKey in environments/environment.sandbox.ts.
    if (domain.indexOf("sandbox.rysemarket.com") !== -1) {
      return null;
    }
    if (domain.indexOf("rysemarket.com") !== -1) {
      return {
        posthogKey: "phc_n2gFvmqqPFwP15pef4uZWdxYT2AzqlZPFQ8IK0aDQJg",
        posthogApiHost: "https://us.i.posthog.com",
      };
    }
    return {
      posthogKey: "phc_C1EVD5x9r34wepyMNjIYCOO4VDvHWpcQpMjUbiikteP",
      posthogApiHost: "https://us.i.posthog.com",
    };
  }

  var config = getApiConfig();
  if (!config) {
    return;
  }

  // ---- PostHog snippet loader -----------------------------------------------
  // This is the official PostHog JS snippet which stubs `window.posthog` with
  // queuing methods, then async-loads `array.js` which replaces the stubs with
  // the real SDK. Safe to call multiple times because of the `e.__SV` guard.
  // Source: https://posthog.com/docs/libraries/js (array.js snippet)
  !(function (t, e) {
    var o, n, p, r;
    e.__SV ||
      ((window.posthog = e),
      (e._i = []),
      (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split(".");
          (2 == o.length && ((t = t[o[0]]), (e = o[1])),
            (t[e] = function () {
              t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            }));
        }
        (p = t.createElement("script")).type = "text/javascript";
        p.async = !0;
        p.src = s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") + "/static/array.js";
        (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(p, r);
        var u = e;
        for (
          void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
            u.people = u.people || [],
            u.toString = function (t) {
              var e = "posthog";
              return ("posthog" !== a && (e += "." + a), t || (e += " (stub)"), e);
            },
            u.people.toString = function () {
              return u.toString(1) + ".people (stub)";
            },
            o =
              "init push capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(
                " "
              ),
            n = 0;
          n < o.length;
          n++
        )
          g(u, o[n]);
        e._i.push([i, s, a]);
      }),
      (e.__SV = 1));
  })(document, window.posthog || []);

  // ---- Init ------------------------------------------------------------------
  // Note: `PosthogService` (Angular) ALSO calls `posthog.init()` in the main
  // webapp. PostHog's SDK detects a previous init via `__loaded` and no-ops on
  // subsequent calls, so this is safe. In the Keycloak theme context this is
  // the only initializer on the page.
  try {
    window.posthog.init(config.posthogKey, {
      api_host: config.posthogApiHost,
      capture_pageview: true,
      person_profiles: "identified_only",
      persistence: "cookie",
      cross_subdomain_cookie: true,
    });
  } catch (err) {
    if (window.console && console.error) {
      console.error("[PostHog] init failed", err);
    }
  }

  // ---- Helpers --------------------------------------------------------------
  function collectProperties(element) {
    var properties = {};
    if (!element || !element.attributes) {
      return properties;
    }
    for (var i = 0; i < element.attributes.length; i++) {
      var attr = element.attributes[i];
      if (attr.name && attr.name.indexOf("data-property-") === 0) {
        properties[toCamelCase(attr.name.slice(14))] = attr.value;
      }
    }
    return properties;
  }

  function toCamelCase(str) {
    return String(str).replace(/-([a-z0-9])/g, function (_m, g) {
      return g.toUpperCase();
    });
  }

  // ---- data-analytics click tracking ----------------------------------------
  // Fires `posthog.capture(eventName, props)` when any element (or its
  // ancestor) with `data-analytics="..."` is clicked. `data-property-*`
  // attributes on that element are captured as event properties.
  function installClickTracking() {
    if (!document || !document.body) {
      return;
    }
    document.body.addEventListener("click", function (event) {
      var target = event.target;
      while (target && target !== document.body) {
        if (target.hasAttribute && target.hasAttribute("data-analytics")) {
          var eventName = target.getAttribute("data-analytics");
          try {
            window.posthog.capture(eventName, collectProperties(target));
          } catch (err) {
            if (window.console && console.error) {
              console.error("[PostHog] capture failed", err);
            }
          }
          break;
        }
        target = target.parentElement;
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", installClickTracking);
  } else {
    installClickTracking();
  }

  // ---- Public globals (backwards-compatible with old Segment-based surface) -
  window.trackCustomEvent = function (eventName, properties) {
    try {
      window.posthog.capture(eventName, properties || {});
    } catch (err) {
      if (window.console && console.error) {
        console.error("[PostHog] trackCustomEvent failed", err);
      }
    }
  };

  window.identifyUser = function (userId, traits) {
    try {
      // Accept either an object (preferred) or a JSON string (legacy
      // behavior from the old Segment-based caller in account.service.ts).
      var resolvedTraits = traits;
      if (typeof traits === "string") {
        try {
          resolvedTraits = JSON.parse(traits);
        } catch (_) {
          resolvedTraits = {};
        }
      }
      window.posthog.identify(userId, resolvedTraits || {});
    } catch (err) {
      if (window.console && console.error) {
        console.error("[PostHog] identifyUser failed", err);
      }
    }
  };
})();
